module.exports = __webpack_public_path__ + "img/deberes.2d232174.png";